const reducer = (state, action) => {
  const { type, payload } = action;
  if (type === 'ROUTE_CHANGED') {
    return { ...state, selectedPage: payload };
  }
  if (type === 'TOGGLE_SIDEBAR') {
    return { ...state, sidebarOpen: !state.sidebarOpen };
  }
  if (type === 'LOGIN') {
    return { ...state, authenticated: true };
  }
  if (type === 'LOGOUT') {
    return { ...state, authenticated: false };
  }
};

export default reducer;
